import clonedeep from 'lodash.clonedeep';
import orderComparator from './order-comparator';
import { HELP_MENU_ID, DESIGN_MENU_ID } from '../constants/common';

function getComputedItems(props) {
  const { items, helpMenuItems, designMenuItems } = props;

  const sortedHelpMenu = helpMenuItems.sort(orderComparator);
  const sortedDesignMenu = designMenuItems.sort(orderComparator);

  const newItems = items.map((item) => {
    const currentItem = clonedeep(item);
    const { subMenu } = currentItem;

    if (currentItem.id === HELP_MENU_ID && subMenu) {
      subMenu.submenu = sortedHelpMenu;
    }

    if (currentItem.id === DESIGN_MENU_ID && subMenu) {
      subMenu.submenu = sortedDesignMenu;
    }

    return currentItem;
  });

  return newItems;
}

export default getComputedItems;
